import React from 'react';
import { Alert } from 'react-bootstrap';
import { getErrorDisplay } from '../../utils/errorUtils';

const ErrorMessage = ({ error }) => {
    if (error) {
        console.log(error);
        return <Alert variant="danger" style={{ marginTop: 8, marginBottom: 0 }}>{getErrorDisplay(error)}</Alert>;
    } else {
        return null;
    }
};

export default ErrorMessage;